// extracted by mini-css-extract-plugin
export var truncate = "_f-0";